var audio_rtlignore_default = {
  "fontElementMap": "mVG7J",
  "container": "OGmBs",
  "customPlayer": "-j3o-",
  "slim": "lhzGq",
  "playPauseButton": "QN6WP",
  "coverImage": "HlFKB",
  "trackDetailsContainer": "ABNt5",
  "controlsContainer": "onl5-",
  "controlsGroup": "HD2Io",
  "sliderContainer": "RUHo9",
  "audioDuration": "zljjf",
  "isLoading": "-cVhK",
  "audioIconButton": "J5dnY",
  "audioVolumeWrapper": "pm-pJ",
  "volumeSliderWrapper": "-wVBV",
  "audioDetails": "HPM3y",
  "authorName": "_3M60b",
  "title": "Qqkvu",
  "audioContextMenuWrapper": "EnY3e",
  "dropdownMenuWrapper": "ZyTxT",
  "dropdownSelectedButton": "AGjUl",
  "dropdownContent": "aGtiC",
  "dropdownContentWithIcon": "C2HR0",
  "audioLoader": "lUOGu"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
